// 公用埋点
export default {
  BUSINESS_PORTAL_INTERFACE_INTERCEPTOR: {
    key: 'portal_interface_interceptor',
    label: '配运工作台-接口记录'
  },
  NO_PERMISSION_REMIND: {
    key: 'portal_no_permission_landingpage_remind',
    label: '配运工作台-无新权限用户落地页提醒'
  }
}
